const META_SKIP = new Set([
  'id',
  'created',
  'created_at',
  'updated',
  'user',
  'user_id',
  'bothering',
  'sleep-memomory-attention',
]);

/**
 * Spłaszcza `data` wywiadu do par [klucz, wartość] do tabeli (m.in. `lifestyle.smoking_status` → `smoking_status`).
 */
export function flattenHealthInterviewDataEntries(interviewData) {
  if (!interviewData || typeof interviewData !== 'object') return [];
  const map = new Map();
  for (const [key, value] of Object.entries(interviewData)) {
    if (META_SKIP.has(key)) continue;
    if (key === 'lifestyle') continue;
    map.set(key, value);
  }
  const ls = interviewData.lifestyle;
  if (ls && typeof ls === 'object' && !Array.isArray(ls) && ls.smoking_status != null && ls.smoking_status !== '') {
    map.set('smoking_status', ls.smoking_status);
  }
  return [...map.entries()];
}
